"use client";
import styles from "./page.module.scss";
import Image from "next/image";
import assetLoader from "@utils/internalImageLoder";
import { useRouter } from "next/navigation";
import Button from "@components/atoms/Button";
import { useIsMobile } from "@hooks/use-mobile";

export default function CarDropTnCPage() {
  const router = useRouter();
  const isMobile = useIsMobile();
  const handleBackClick = () => {
    router.back();
  };
  return (
    <main className={styles.carDropTnC}>
      <div className={styles.container}>
        <Button className={styles.backButton}>
          {isMobile && (
            <Image
              src={`${assetLoader()}/icons/Chevron_left_light.svg`}
              alt="Back"
              width={32}
              height={32}
              loading="eager"
              onClick={handleBackClick}
            />
          )}
          ACKO Drive Car Drop Terms and Conditions
        </Button>
        <section className={styles.section}>
          <p className={styles.paragraph}>
            This ACKO Drive Car Drop Program (&quot;Car Drop&quot;) is brought
            to you by ACKO Technology and Services Private Limited
            (&quot;ACKO&quot;) wherein you stand a chance to win a Car including
            other exciting discounts and offers as determined by ACKO and
            detailed under the &quot;PRIZE&quot; Section (&quot;Prize/s&quot;).
          </p>
        </section>

        <section className={styles.section}>
          <p className={styles.paragraph}>
            Please read these terms and conditions (&quot;T&C&quot;) before
            entering the Car Drop. By participating in this Car Drop, you agree
            to be bound by these T&C and you acknowledge and agree that you
            satisfy all Car Drop eligibility requirements and terms as provided
            herein below.
          </p>
        </section>

        <section className={styles.section}>
          <p className={styles.paragraph}>
            These T&Cs are in addition to the ACKO&apos;s Terms of Use and
            Privacy Policy to which you agree by using the mobile application of
            ACKO, or the ACKO Website, or the Acko Drive Website (&quot;ACKO
            Platform/s&quot;).
          </p>
        </section>

        <section className={styles.section}>
          <p className={styles.paragraph}>
            For the purposes of these T&Cs, wherever the context so requires
            &quot;You&quot; or &quot;Your&quot; shall mean any natural person
            who is a participant in the Car Drop and meets the Eligibility
            Criteria set out in the &quot;ELIGIBILITY&quot; Section below.
          </p>
        </section>

        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>ELIGIBILITY:</h2>

          <p className={styles.paragraph}>
            You confirm and agree that you fulfill the following eligibility
            criteria to enter this Car Drop:
          </p>

          <ul className={styles.list}>
            <li className={styles.listItem}>
              You are an individual above the age of eighteen (18) years;
            </li>
            <li className={styles.listItem}>
              You are currently a resident of India;
            </li>
            <li className={styles.listItem}>
              You have sound legal mind and competent to enter into a binding
              legal agreement;
            </li>
            <li className={styles.listItem}>
              You have a valid proof of identity and age in the form of a copy
              of Aadhar Card / Driving License / Voter ID / Indian passport;
            </li>
            <li className={styles.listItem}>You have a PAN Card; and</li>
            <li className={styles.listItem}>
              You meet and have complete all the steps detailed under the
              &quot;DETAILS OF THE CAR DROP AND HOW TO ENTER&quot; Section
              below.
            </li>
          </ul>
        </section>

        <section className={styles.section}>
          <p className={styles.paragraph}>
            Employees of ACKO including their immediate family members (spouses,
            domestic partners, parents, grandparents, siblings, children and
            grandchildren), and ACKO&apos;s affiliates, advisors, and
            advertising / Car Drop agencies are not eligible to enter this Car
            Drop or otherwise claim any Prize/s.
          </p>
        </section>

        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>
            DETAILS OF THE CAR DROP AND HOW TO ENTER:
          </h2>

          <ul className={styles.list}>
            <li className={styles.listItem}>
              This Car Drop will be available as per the &quot;Car Drop
              Period&quot; specified under the Car Drop Section on ACKO
              Platform/s.
            </li>
            <li className={styles.listItem}>
              To enter, you must, during the Car Drop Period:
              <ul className={styles.list}>
                <li className={styles.listItem}>
                  Log in to the ACKO App or ACKO Drive Platform.
                </li>
                <li className={styles.listItem}>
                  Have an active car policy from ACKO and also active on the
                  date of the announcement of Winner/s;
                </li>
                <li className={styles.listItem}>
                  Click the &quot;&lt;Participate&gt;&quot; or &quot;&lt;Opt
                  in&gt;&quot; button during the Car Drop Period.
                </li>
                <li className={styles.listItem}>
                  Complete a &quot;Wishlist A Car&quot; Survey, to complete the
                  entry submission for the Car Drop.
                </li>
              </ul>
            </li>
            <li className={styles.listItem}>
              If you do not have an account on any of the Acko Platform/s, you
              will be required to sign-up for an ACKO account, to be able to
              enter into this Car Drop. Only one entry per user / account on
              ACKO Platform per month is allowed. ACKO reserves the right to
              verify the eligibility of all participants.
            </li>
            <li className={styles.listItem}>
              Based on the result of the Car Drop, winner/s will proceed to
              claim their respective Prize, subject to the terms provided
              hereunder.
            </li>
            <li className={styles.listItem}>
              Such number of participants as specified under &quot;PRIZE&quot;
              Tab on the Car Drop Section on the ACKO Platform will be selected
              as the winner/s for each Prize through a random computerized draw
              of lots, conducted from among all eligible participants who have
              successfully completed the &quot;Wishlist a Car&quot; Survey
              activity during the Car Drop Period.
            </li>
            <li className={styles.listItem}>
              Participation in the &quot;Wishlist a Car&quot; Survey is a
              prerequisite to being included in the pool for winners of the
              Prize for the Car Drop. Completion of the Survey by you does not
              guarantee a win. The car selected or wish-listed by the
              participant as part of the survey process is indicative in nature
              and does not guarantee a win, or the make, model, or variant of
              the vehicle that may be awarded as a Prize. The final Prize shall
              be determined and provided at the sole discretion of ACKO.
            </li>
            <li className={styles.listItem}>
              The winner announcements will be carried out on such date as
              specified under the Car Drop Section on the Acko Platform/s.
            </li>
            <li className={styles.listItem}>
              Tax shall be the sole responsibility of the winner/s as per
              &quot;TAXATION AND COST&quot; Section below.
            </li>
          </ul>
        </section>

        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>PRIZES:</h2>
          <ul className={styles.list}>
            <li className={styles.listItem}>
              Subject to fulfillment of these T&Cs, the &quot;Prize/s&quot; as
              specified under the &quot;Prize&quot; Tab of the Car Drop Section
              on the Acko Platform will be awarded to such number of
              participants (each a &quot;Winner/s&quot;).
            </li>
            <li className={styles.listItem}>
              The Prize of the car, including its color, variant, version, etc.
              shall be at the sole discretion of ACKO. The actual Prize may
              differ in color and appearance.
            </li>
            <li className={styles.listItem}>
              No changes or upgrades by the Winner will be allowed. The Prize is
              personal to the Winner/s being the account holder on the ACKO
              Platform and is non-transferable.
            </li>
            <li className={styles.listItem}>
              {" "}
              If you win a Prize, you cannot transfer, assign, or otherwise
              redeem the Prize for cash, or seek an upgrade or change of color,
              car accessories, variant or versions.
            </li>
            <li className={styles.listItem}>
              Only the original OEM warranty, as provided and declared by the
              manufacturer / OEM, shall apply to the Prize/s. ACKO shall not be
              liable either for the payment of any additional costs or for the
              provision of any warranty/ies for the Prize/s. The OEM shall be
              solely responsible for all warranty obligations and related
              services.
            </li>
            <li className={styles.listItem}>
              {" "}
              ACKO shall not be responsible for facilitating or providing
              BHARAT-series registration for the winning Car. The vehicle
              registration shall be carried out only in the state or union
              territory of current residence of the prize winner or permanent
              address specified in the documentary address proof provided by the
              Winner/s, strictly in accordance with the provisions of the Motor
              Vehicles Act, 1988 and the rules framed thereunder.
            </li>
          </ul>
        </section>
        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>TAXATION AND COSTS:</h2>
          <ul className={styles.list}>
            <li className={styles.listItem}>
              All Prizes are subject to applicable Indian tax laws, including
              TDS under Section 194B of the Income Tax Act, 1961, road tax, etc.
            </li>
            <li className={styles.listItem}>
              All taxes are payable by the Winner/s before collecting the
              Prize/s.
            </li>
            <li className={styles.listItem}>
              In case of cashbacks / discounts as Prize/s, ACKO shall deduct the
              applicable TDS before delivery of the Prize to the Winner, within
              the stipulated timeline.
            </li>
            <li className={styles.listItem}>
              {" "}
              All payments and processing fees related to vehicle registration
              with the Regional Transport Office (“RTO”) shall be borne by ACKO.
              The Winner shall provide all necessary assistance and cooperation,
              including submission of required documentation and paperwork, to
              facilitate registration and compliance with applicable RTO rules
              and regulations.
            </li>
            <li className={styles.listItem}>
              The Prize will be delivered only after the Winner/s has paid the
              necessary tax and any other related or incidental charges, prior
              to the delivery date.
            </li>
            <li className={styles.listItem}>
              The Winner/s will be provided with a TDS certificate (Form 16A)
              for their tax records.
            </li>
            <li className={styles.listItem}>
              Failure or refusal to pay the applicable TDS or any other taxes,
              duties, or charges as required under Indian law will result in
              automatic cancellation or forfeiture of the Prize/s.
            </li>
            <li className={styles.listItem}>
              In case of breach of any T&C, ACKO reserves the right, at its sole
              discretion, to either select an alternate Winner/s or to withdraw
              the Prize/s altogether, without any further obligation or
              liability in the event of breach of the above by the Winner/s
            </li>
          </ul>
        </section>
        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>PRIZE DRAWING:</h2>
          <ul className={styles.list}>
            <li className={styles.listItem}>
              ACKO will notify the winning participants, eligible to claim the
              Prize, by call, e-mail and WhatsApp.
            </li>
            <li className={styles.listItem}>
              By agreeing to participate and enter into this Car Drop, you agree
              that you have a valid proof of identity and age in the form of a
              copy of PAN Card / Driving License / Voter ID / Indian passport
              and you may be required to share the said documents with ACKO as
              and when requested. You may also be requested for additional
              documents by the dealer / OEM, you confirm to provide such
              documents upon request at the earliest.
            </li>
            <li className={styles.listItem}>
              The procedure of claiming the Prize will be as instructed by ACKO
              as also briefly detailed under the “WINNER OBLIGATIONS” Section
              below, wherein you may be required to visit appropriate ACKO
              Office physically, and web-links and provide requisite details.
              Each Prize will be awarded &quot;AS IS&quot; and WITHOUT WARRANTY
              OF ANY KIND, express or implied (including, without limitation,
              any implied warranty of merchantability or fitness for a
              particular purpose).
            </li>
            <li className={styles.listItem}>
              The car you list on your “Wishlist a Car Survey” is provided for
              illustrative purposes only and does not constitute a guarantee or
              warranty that you will receive that specific car. ACKO reserves
              the exclusive right to select and award any car at its sole
              discretion.
            </li>
            <li className={styles.listItem}>
              Winners will be selected through a random computerized draw from
              all eligible entries that have successfully completed the
              qualifying Survey. The draw process will be independently verified
              or audited by ACKO’s appointed internal or third-party auditors to
              ensure fairness and transparency.
            </li>
            <li className={styles.listItem}>
              Odds of winning depend on the number of eligible entries received.
              Eligible entries are ones that satisfy the eligibility criteria
              outlined above and follow the steps outlined in the &quot;DETAILS
              OF THE CAR DROP AND HOW TO ENTER&quot; section above and complete
              the assigned task. Decisions of ACKO shall be final and binding.
            </li>
          </ul>
        </section>
        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>PRIZE DELIVERY:</h2>
          <ul className={styles.list}>
            <li className={styles.listItem}>
              Winners of the Prize/s shall be required to execute a winner’s
              agreement, in such form and manner as may be prescribed by ACKO,
              as a precondition to claiming or receiving the Prize/s.
            </li>
            <li className={styles.listItem}>
              The date, timeline and location of delivery of the Prize shall be
              determined and communicated to the Winner prior to the delivery by
              ACKO. ACKO’s decision shall be final and binding. No delivery
              location preferences of the winner will be accepted. Delivery of
              other Prizes shall be facilitated by ACKO.
            </li>
            <li className={styles.listItem}>
              Delivery timelines are also subject to OEM availability and
              standard registration timelines. ACKO shall not be liable or
              responsible for any such delays. ACKO shall not be responsible for
              any delays caused by dealer, OEM, logistics, RTO Office, or other
              third parties. While, under optimal circumstances, the overall
              process may take approximately two to three (2–3) months, actual
              delivery timelines may vary.
            </li>
            <li className={styles.listItem}>
              The Prizes including the car will be registered in the name of the
              Winner only and cannot be transferred.
            </li>
          </ul>
        </section>
        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>ANNOUNCEMENT OF WINNER:</h2>
          <p className={styles.paragraph}>
            After ACKO confirms the Winner/s, ACKO will contact each winner
            individually through call, email and WhatsApp. ACKO will also post
            the winners&apos; names under the Winner’s Tab under the Car Drop
            Section on the ACKO Platform. If we do not receive a response from
            the Winner/s within two (2) day, your claim to the Prize/s shall
            stand forfeited and ACKO shall have the right to decide / announce
            another winner. Decisions of ACKO shall be final and binding.
          </p>
        </section>
        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>WINNER OBLIGATIONS:</h2>
          <ul className={styles.list}>
            <li className={styles.listItem}>
              Upon being notified as a Winner of the Prize of a Car, the Winner
              shall have FORTY EIGHT (48) Hours to execute the winner agreement
              and to pay an amount of Rs. 50,000/- as an advance towards
              applicable TDS and for confirmation of acceptance of the Prize of
              the car. The said advance is non-refundable.
            </li>
            <li className={styles.listItem}>
              All Winners are required to provide their personal details,
              including a mobile number, to claim the Prize/s. ACKO reserves the
              right to verify the accuracy and authenticity of these details
              including compliance with these T&C before delivering the Prize/s.
            </li>
            <li className={styles.listItem}>
              The remaining tax shall be payable seven (7) days prior to
              delivery of the Prize. In case the Winner/s fails to pay the
              remaining TDS / tax within the above date, ACKO shall have the
              absolute right to cancel the Prize and forfeit the entire advance
              amount, including all portions already paid. Breach of these T&C
              and/or the winner agreement shall also entitle ACKO to cancel the
              prize and forfeit the entire advance amount, including any portion
              already paid.
            </li>
            <li className={styles.listItem}>
              Failure to submit the advance and/or balance tax amount within the
              stipulated timeframe/s shall entitle ACKO, at its sole discretion,
              to cancel the Prize and/or forfeit the entire advance tax amount
              (if paid) and/or declare another Winner/s.
            </li>
            <li className={styles.listItem}>
              All actions and timelines mentioned herein are at the sole
              discretion of ACKO, and ACKO reserves the right to modify or
              determine alternative timelines in exceptional circumstances.
            </li>
            <li className={styles.listItem}>
              The Winner must provide all necessary cooperation, assistance, and
              documentation, including but not limited to identity proofs,
              address proofs, declarations, and executed agreements, in a timely
              manner. Such documentation and assistance must be provided in the
              form and manner as may be requested by ACKO, or as required under
              any applicable law, regulation, or governmental authority. Failure
              to provide such cooperation or documentation within the stipulated
              timelines may result in disqualification or forfeiture of the
              prize at the sole discretion of ACKO.
            </li>
          </ul>
        </section>
        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>
            DISCLAIMERS AND ADDITIONAL TERMS:
          </h2>
          <ul className={styles.list}>
            <li className={styles.listItem}>
              ACKO may, to the maximum extent permitted by applicable law and in
              its sole discretion, change any of the terms of these T&Cs or
              cancel the Car Drop at any time; or modify, terminate, or suspend
              the Car Drop should viruses, worms, bugs, unauthorized human
              intervention or other causes beyond its control corrupt or impair
              the administration, security, fairness or proper play of the Car
              Drop or submission of entries.
            </li>
            <li className={styles.listItem}>
              ACKO shall not be responsible for: (a) Entries that are lost,
              misdirected, delayed, incomplete, unintelligible, or contain
              inaccurate information, whether due to user error, technical or
              programming issues related to the Car Drop, or any technical or
              human errors during the entry processing; (b) Any printing or
              typographical mistakes in materials associated with the Car Drop
              or Materials; (c) Operational failures, transmission errors,
              destruction, unauthorized access to, or alteration of entries, or
              any technical issues involving networks, telephones, computers,
              hardware, or software, including issues caused by internet
              congestion or other connectivity problems that result in
              inaccurate or failed receipt of entry data; (d) Any harm or damage
              to your or any other person’s computer or mobile device resulting
              from downloading Materials in connection with the Car Drop.
            </li>
            <li className={styles.listItem}>
              ACKO reserves the right, at its sole discretion, to disqualify any
              individual found to be from entering or winning (despite the
              winner announcement) in the event of: (a) Tampering with the entry
              process or the functioning of the Car Drop or any property
              belonging to ACKO or its affiliates, including but not limited to
              ACKO.in; (b) Violating or breaching these T&C or any part thereof;
              or (c) Acting in a disruptive, unsportsmanlike manner, or with the
              intent to harass, abuse, threaten, or annoy others; (d) fraud,
              cheating or other misconduct; (e) breach of any applicable laws or
              eligibility criteria. Entries that are incomplete, or submitted
              using robotic, automatic, programmed, or other similar methods,
              will be deemed void and rejected.
            </li>
            <li className={styles.listItem}>
              In the event of any breach of these T&C or the Winner Agreement by
              any Winner/s, as determined solely by ACKO, ACKO reserves the
              right to, at its sole discretion to: (a) forfeit the entire
              advance tax and/or any advance amount paid by the Winner, and (b)
              cancel the Prize in its entirety, or declare another Winner,
              and/or add the forfeited Prize value to the subsequent month’s
              prize pool.
            </li>
            <li className={styles.listItem}>
              Subject to the laws of India, with courts of Bangalore having the
              exclusive jurisdiction.
            </li>
          </ul>
        </section>
        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>PUBLICITY AND CONSENTS:</h2>
          <ul className={styles.list}>
            <li className={styles.listItem}>
              By participating in the Car Drop, you irrevocably grant ACKO
              and/or its affiliates, agents, licensees, partners, and assigns
              the unrestricted, perpetual, worldwide right to use, reproduce,
              edit, adapt, modify, publish, display, broadcast, distribute, and
              otherwise exploit, in whole or in part, your name, likeness,
              photograph, image, voice, persona, statements, biographical
              details, social media handle(s), saved item details, and any other
              personal attributes or materials provided or captured in
              connection with the Car Drop (collectively, the
              &quot;Materials&quot;), in any format or medium now known or
              hereafter developed, including but not limited to print, film,
              audio, video, social media, digital, or online platforms.
            </li>
            <li className={styles.listItem}>
              You acknowledge and agree that: (a) ACKO and its affiliates shall
              have sole and exclusive ownership of all rights, title, and
              interest in and to the Materials, including all copyrights and
              other intellectual property rights; (b) ACKO and its affiliates,
              agents, licensees, partners, and assigns shall have full rights to
              use, not use, edit, or exploit the Materials at its sole
              discretion, for any purpose whatsoever, including (without
              limitation) for promotional, marketing, advertising, publicity,
              internal, commercial, editorial, and educational purposes; (c) You
              shall not receive, and expressly waive any claim to, any
              compensation, royalties, credit, or other remuneration in
              connection with the use of the Materials; (d) You release and
              discharge ACKO and its Affiliates from any and all claims,
              demands, liabilities, or causes of action arising out of or in
              connection with the use of the Materials, including without
              limitation any claims for defamation, invasion of privacy,
              infringement of moral rights, or violation of any right of
              publicity.
            </li>
            <li className={styles.listItem}>
              Further, upon request by ACKO, you agree to: (a) Make yourself
              reasonably available at the time and location specified by ACKO,
              without additional compensation, for the creation of content or
              promotional materials, including but not limited to photo or video
              shoots, interviews, testimonials, press interactions, or public
              appearances, whether in-person or virtual; (b) Provide written,
              audio, or video testimonials regarding your experience with the
              Car Drop or any ACKO initiative, in the form and format requested
              by ACKO; (c) Participate in any follow-up campaigns, events, or
              promotions related to or arising from the Car Drop, as may be
              reasonably required by ACKO or its affiliates.
            </li>
            <li className={styles.listItem}>
              By entering the Car Drop, you also consent to being placed on a
              mailing and/or marketing list for promotional and other materials
              for ACKO and/or its affiliates.
            </li>
            <li className={styles.listItem}>
              Additionally, if you choose to withdraw or drop out of the Car
              Drop at any stage, ACKO reserves the right to publicly disclose
              your withdrawal.
            </li>
            <li className={styles.listItem}>
              By accepting a Prize/s, you agree to publicly announce and promote
              your win on your social media channels in the form and manner
              approved by ACKO. You further agree to cooperate with ACKO in
              providing any necessary content or approvals to facilitate such
              promotion. ACKO reserves the right, at its sole discretion, to
              repost, share, or otherwise use any such social media posts made
              by you across any of its channels or platforms. These posts shall
              be considered part of the “Materials” as defined herein and are
              subject to the same rights and usage granted to ACKO under these
              terms.
            </li>
            <li className={styles.listItem}>
              This consent and release is irrevocable, binding, and shall remain
              in effect without any time limitation.
            </li>
          </ul>
        </section>
        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>INTELLECTUAL PROPERTY:</h2>
          <p className={styles.paragraph}>
            This Car Drop, and all accompanying Materials are the intellectual
            property of ACKO, or its affiliates. All rights reserved. No
            requests for transfer or assignment or redemption of the benefits
            shall be entertained. You agree that all decisions made by ACKO
            related to the Car Drop are final and binding on you. Failure by
            ACKO to enforce any of these T&Cs in any instance shall not be
            deemed to be a waiver of the T&Cs and shall not give rise to any
            claim by any person. These T&Cs are governed by the laws of India
            and courts at New Delhi shall have the exclusive jurisdiction in
            respect of any disputes or any matter arising here from.
          </p>
        </section>
        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>LIABILITY AND WAIVER:</h2>
          <p className={styles.paragraph}>
            ACKO may, at its sole discretion, bar you from participating in any
            future Car Drop events or related promotions in the event of breach
            of any T&C. This Car Drop is being made purely on a &quot;best
            effort&quot; basis and participating in this Car Drop is voluntary.
            By participating in the Car Drop, you will be legally bound hereby,
            to release from liability, and hold harmless ACKO, and any of its
            affiliates, employees or agents representing or related to ACKO and
            its services/products. This release is for any and all liability for
            personal injuries (including death), property loss or damage, and
            misuse of the benefits/ Prizes offered under this Car Drop, in
            connection with any activity or directly or indirectly, by reason of
            the acceptance, possession, or participation in the Car Drop, even
            if caused or contributed to by ACKO&apos;s negligence. To the
            fullest extent permitted by applicable law, ACKO and its affiliates,
            officers, directors, employees, agents, and representatives (“ACKO
            Parties”) expressly disclaim all warranties, representations, and
            guarantees, whether express or implied, including but not limited to
            warranties of merchantability, fitness for a particular purpose, and
            non-infringement. ACKO does not guarantee the availability,
            accuracy, completeness, or reliability of any products, services,
            offers, or content associated with the Car Drop or any related
            promotions. Participation is at the participant’s sole risk. In no
            event shall ACKO Parties be liable for any direct, indirect,
            incidental, consequential, special, punitive, or exemplary damages,
            including but not limited to loss of profits, goodwill, use, data,
            or other intangible losses arising out of or in connection with
            participation in the Car Drop, acceptance, possession, use, or
            misuse of any prize, or any technical or other difficulties
            encountered, even if advised of the possibility of such damages.
            ACKO shall not be responsible or liable for: Any technical errors,
            malfunctions, failures, delays, or disruptions beyond its reasonable
            control, including but not limited to those arising from internet
            connectivity, platform performance, third-party systems, or force
            majeure events; Any disputes, defects, or issues related to the car
            after delivery. All such matters shall be governed solely by the
            applicable original equipment manufacturer warranty, and
            participants are expected to approach the respective dealer or OEM
            directly; Any injury, loss, damage, or harm (whether direct or
            indirect, incidental or consequential) arising out of or in
            connection with participation in the Contest, inability to
            participate, or acceptance, use, or misuse of the Prize/s.
          </p>
        </section>
        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>OTHER CAR DROPS:</h2>
          <p className={styles.paragraph}>
            Please note that ACKO may be running similar Car Drops or promotions
            on a monthly basis. If you are declared a Winner of any Prize/s in
            any Car Drop, you will not be eligible to enter and/or receive any
            benefit and/ or prize awarded in any other promotion/ Car Drop.
          </p>
        </section>
        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>CONTACT:</h2>
          <p className={styles.paragraph}>
            For any details regarding the Car Drop and the Prizes thereof,
            please contact ACKO Customer Care at cardrop@ackodrive.com.
          </p>
        </section>
        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>PRIVACY POLICY:</h2>
          <p className={styles.paragraph}>
            All information and data submitted in connection with this Car Drop
            will be treated in accordance with these T&Cs and the Privacy Notice
            available at ACKO.
          </p>
        </section>
      </div>
    </main>
  );
}
